module.exports = __webpack_public_path__ + "media.74348d63af026714626d.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/media/webfont/media.woff
// module id = ../../../../../src/assets/fonts/line-icons-pro/media/webfont/media.woff
// module chunks = styles